/* global $:true module:true Flickity:true Foundation:true */

import debug from "debug";
const MODULE_NAME = 'core/modules/sliders';
const log = debug(MODULE_NAME);

import blocks from './blocks';


export function exec () {
	$(document).ready(() => {
		log('loading slider modules');
		blocks();
	});
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/sliders/index.js